exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-mask{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:table;transition:opacity .3s ease;display:flex;justify-content:center;align-items:center}.modal-container{width:972px;height:584px;border-radius:3px;box-shadow:15px 20px 30px 0 rgba(0,0,0,.12);border:.5px solid #ededed;padding:20px 30px;background-color:#fff;transition:all .3s ease}.madal-close{font-size:50px;display:block;border:none;background-color:inherit;margin-left:auto;cursor:pointer}.modal-enter,.modal-leave-active{opacity:0}.modal-enter .modal-container,.modal-leave-active .modal-container{-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68199bed","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modal.vue
// module id = 115
// module chunks = 0